var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInjektionSmall = function SvgInjektionSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#injektion-small_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "injektion-small_svg__b",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 0H0v32h32z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#injektion-small_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#90BA1E",
    d: "M25.194 9.942c.38.384.76.773 1.132 1.156l.862-.834c-1.501-1.55-5.076-5.187-5.85-5.514l-.476 1.102c.161.082.585.447 1.162.983-.397.381-1.008.952-1.63 1.525-.835-.84-1.492-1.527-1.693-1.803l-.97.707c.123.17.38.456.71.806-1.885 1.775-9.724 9.185-10.707 10.546-.227.315-.338.75.86 2.195-.3.304-.521.6-.556.647l-.26.353.257.355c.115.16.26.35.42.546-.836.909-2.708 2.899-4.17 4.13l.774.917c1.5-1.264 3.357-3.231 4.232-4.18.224.185.45.332.66.386.37.088.72-.094 1.161-.634.794.63 1.248.797 1.568.797a1 1 0 0 0 .254-.036c.188-.055.634-.188 10.948-10.645l.527.505.829-.869c-.4-.38-.965-.922-1.596-1.533a61 61 0 0 1 1.552-1.608m-12.581 12.95c-.158-.072-.525-.28-1.21-.882l-.512-.448-.381.564c-.186.275-.33.454-.43.562-.202-.17-.503-.495-.794-.86.149-.167.331-.352.5-.474l.537-.39-.44-.495c-.568-.639-.893-1.103-1.024-1.34.23-.274.628-.698 1.129-1.212.307.286.634.57.986.864.93.777 1.972 1.656 2.9 2.942-.586.562-1.034.98-1.261 1.168m7.562-7.41c-.555-.5-1.204-1.25-1.212-1.26l-.91.783c.033.038.67.773 1.275 1.327l-.755.756a17 17 0 0 0-1.188-1.125l-.785.907c.34.294.83.749 1.123 1.066l-.857.853c-.457-.42-1.02-.965-1.184-1.2l-.983.687c.247.354.89.968 1.313 1.358-.451.445-.877.865-1.267 1.245-.992-1.335-2.096-2.261-3.001-3.018a24 24 0 0 1-.913-.797c2.46-2.461 6.359-6.168 8.443-8.13a220 220 0 0 0 3.743 3.682c-.87.882-1.842 1.862-2.842 2.866m2.605-4.767a259 259 0 0 1-1.535-1.506c.815-.75 1.326-1.23 1.65-1.546.449.432.942.918 1.453 1.428a46 46 0 0 0-1.568 1.624"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "injektion-small_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgInjektionSmall;